<template>
  <b-form-group :label="label" :label-for="id">
    <div :id="id" class="d-flex flex-column align-items-center justify-content-center">
      <div
        class="image-wrapper mb-2 position-relative"
        style="max-width: 150px; width: 100%; max-height: 150px; aspect-ratio: 1/1 !important"
      >
        <b-button
          v-if="value"
          variant="danger"
          @click="removeImage"
          style="position: absolute; top: 0px; right: 0; z-index: 1000"
          size="sm"
          class="btn-icon"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>

        <b-overlay
          :show="loading"
          rounded="sm"
          opacity="0.5"
          spinner-variant="primary"
          class="w-100 h-100 rounded bg-secondary cursor-pointer overflow-hidden"
        >
          <img
            v-if="imagePreviewUrl || value || defaultValue"
            :src="imagePreviewUrl || value || defaultValue"
            alt="Image"
            class="w-100 h-100"
            style="object-fit: contain"
            @click="openFileInput"
          />
          <div
            v-else
            class="w-100 h-100 d-flex align-items-center justify-content-center"
            @click="openFileInput"
          >
            <feather-icon icon="ImageIcon" class="text-muted" size="2x" />
          </div>
        </b-overlay>
      </div>
      <b-form-file
        v-model="imageFile"
        :placeholder="placeholder"
        :state="state"
        ref="fileInput"
        accept="image/*"
        class="w-100"
        @change="handleFileChange"
        style="display: none"
      />
    </div>
  </b-form-group>
</template>

<script>
import { APIService } from '@/utils/api';
import { BButton, BFormFile, BFormGroup, BOverlay } from 'bootstrap-vue';

export default {
  name: 'ImageField',
  components: {
    BFormFile,
    BButton,
    BFormGroup,
    BOverlay,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
    },
    state: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      imagePreviewUrl: null,
      imageFile: null,
    };
  },
  watch: {
    value: {
      handler(newVal) {
        // If there's a new value from the parent component, clear any local preview
        if (newVal && !this.imagePreviewUrl) {
          // We're not changing imagePreviewUrl here since we want to display the value directly
          // This ensures changes from parent are reflected
          console.log('[ImageField] Received value update:', newVal);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    console.log('=== [ImageField] Mounted:', this.value);

    this.imagePreviewUrl = this.value;
    // No need to set imagePreviewUrl if we have value
    // The template will use value directly if imagePreviewUrl is null
  },
  methods: {
    removeImage() {
      this.imageFile = null;
      this.imagePreviewUrl = null;
      this.$emit('input', null);
    },
    openFileInput() {
      if (this.$refs.fileInput) {
        const nativeInput = this.$refs.fileInput.$el.querySelector('input[type="file"]');
        if (nativeInput) {
          nativeInput.click();
        }
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Show local preview immediately
      this.imagePreviewUrl = URL.createObjectURL(file);

      // Start upload
      this.loading = true;

      // Use either store dispatch or APIService, depending on what's available
      const uploadMethod = APIService.uploadFile(file);

      Promise.resolve(uploadMethod)
        .then((url) => {
          // Emit the uploaded URL as the new value for v-model
          this.$emit('input', url);
        })
        .catch((error) => {
          console.error('Error uploading file:', error);
          this.$emit('input', null);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
